import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { publicWorkflow, workflowError, displayDate } from '../utils/electionWorkflows';

export default function NdaReview() {
  const [token] = useState(() => window.location.hash.slice(1));
  const [agreement, setAgreement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [signedName, setSignedName] = useState('');
  const [consent, setConsent] = useState(false);
  useEffect(() => {
    let active = true;
    publicWorkflow('nda-review', { token }).then(response => {
      if (active) setAgreement(response.data.data);
    }).catch(err => { if (active) setError(workflowError(err)); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [token]);
  const accept = async event => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const response = await publicWorkflow('nda-accept', { token, signedName, consent });
      setAgreement({ ...agreement, ...response.data.data });
    } catch (err) { setError(workflowError(err)); }
    finally { setBusy(false); }
  };
  return <main className="container py-5" style={{ maxWidth: 850 }}>
    <Link to="/">VoteWave</Link>
    <h1 className="mt-3">Election NDA</h1>
    {loading && <p role="status">Loading agreement...</p>}
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {agreement && <>
      <h2 className="h4">{agreement.title}</h2>
      <p>{agreement.electionName} · Version {agreement.version} · For {agreement.recipientName}</p>
      <div className="card p-4 mb-4" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{agreement.content}</div>
      {agreement.acceptedAt ? <div className="alert alert-success" role="status">
        Accepted by {agreement.signedName} on {displayDate(agreement.acceptedAt)}.
      </div> : <form onSubmit={accept}>
        <p>This link expires {displayDate(agreement.expiresAt)}. Opening this page does not accept the agreement.</p>
        <label htmlFor="nda-signature" className="form-label">Type your full name</label>
        <input id="nda-signature" className="form-control mb-3" value={signedName}
          onChange={event => setSignedName(event.target.value)} maxLength={255} required />
        <div className="form-check mb-3">
          <input id="nda-consent" type="checkbox" className="form-check-input" checked={consent}
            onChange={event => setConsent(event.target.checked)} required />
          <label htmlFor="nda-consent" className="form-check-label">
            I am the intended recipient, have read this version of the NDA, and agree to its terms.
          </label>
        </div>
        <button className="btn btn-primary" disabled={busy || !consent || !signedName.trim()}>
          {busy ? 'Recording...' : 'Accept NDA'}
        </button>
      </form>}
    </>}
  </main>;
}
